// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Orbitron', 'Orbitron Fallback'","fontStyle":"normal"},"className":"__className_c30b06","variable":"__variable_c30b06"};